module.exports = __webpack_public_path__ + "static/media/guide-menu-2.01ee333f.png";